import { useMutation } from "@tanstack/react-query";
import { apiClient } from "@/lib/apiClient";
import { apiPath } from "@/lib/apiPath";

interface SignupPayload {
    phone: string;
    company_id: number;
    name?: string;
    email?: string;
    password?: string;
}

interface LoginPayload {
    phone: string;
    password: string;
    company_id: number;
}

interface AuthResponse {
    access_token: string;
    expires_in: number;
    client_id: number;
    phone: string;
    is_verified: boolean;
    name?: string;
}

interface OtpRequestPayload {
    phone: string;
    company_id: number;
}

interface OtpRequestResponse {
    message: string;
    expires_in: number;
}

interface OtpVerifyPayload {
    phone: string;
    code: string;
}

interface OtpVerifyResponse {
    verified: boolean;
}

export function useClientSignup() {
    return useMutation({
        mutationKey: ["client", "signup"],
        mutationFn: async (payload: SignupPayload): Promise<AuthResponse> => {
            const { data } = await apiClient.post(apiPath("/public/client/signup"), payload);
            return data;
        },
    });
}

export function useClientLogin() {
    return useMutation({
        mutationKey: ["client", "login"],
        mutationFn: async (payload: LoginPayload): Promise<AuthResponse> => {
            const { data } = await apiClient.post(apiPath("/public/client/login"), payload);
            return data;
        },
    });
}

export function useRequestOtp() {
    return useMutation({
        mutationKey: ["client", "otp", "request"],
        mutationFn: async (payload: OtpRequestPayload): Promise<OtpRequestResponse> => {
            const { data } = await apiClient.post(apiPath("/public/client/otp/request"), payload);
            return data;
        },
    });
}

export function useVerifyOtp() {
    return useMutation({
        mutationKey: ["client", "otp", "verify"],
        mutationFn: async (payload: OtpVerifyPayload): Promise<OtpVerifyResponse> => {
            const { data } = await apiClient.post(apiPath("/public/client/otp/verify"), payload);
            return data;
        },
    });
}
